/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Represents a billing period with start and end dates
*/
export class BillingPeriod {
  /**
  * Start date and time of the billing period in ISO 8601 format
  */
  '_from': Date;
  /**
  * End date and time of the billing period in ISO 8601 format
  */
  'to': Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_from",
      "baseName": "from",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "to",
      "baseName": "to",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return BillingPeriod.attributeTypeMap;
  }

  public constructor() {
  }
}

